import apiClient from '../../../shared/api/client';
import { PaginatedFavoritesResponse } from '../types';

class FavoritesService {
  private readonly baseUrl = '/favorites';

  async getFavoriteOffers(
    page: number = 1,
    limit: number = 5
  ): Promise<PaginatedFavoritesResponse> {
    return await apiClient.get<PaginatedFavoritesResponse>(`${this.baseUrl}/offers`, {
      params: { page, limit },
    });
  }

  async toggleFavorite(offerId: string, isFavorite: boolean): Promise<void> {
    if (isFavorite) {
      // Remove from favorites
      await apiClient.delete(`${this.baseUrl}/${offerId}`);
    } else {
      // Add to favorites
      await apiClient.post(`${this.baseUrl}/${offerId}`);
    }
  }

  async getCount(): Promise<{ count: number }> {
    return await apiClient.get<{ count: number }>(`${this.baseUrl}/count`);
  }
}

export default new FavoritesService();
